import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _taggedTemplateLiteralLoose from 'babel-runtime/helpers/taggedTemplateLiteralLoose';
import _regeneratorRuntime from 'babel-runtime/regenerator';

var _templateObject = _taggedTemplateLiteralLoose(['\n  mutation learnerFeedback($feedback: LearnerFeedback!) {\n    learnerFeedback(feedback: $feedback)\n  }\n'], ['\n  mutation learnerFeedback($feedback: LearnerFeedback!) {\n    learnerFeedback(feedback: $feedback)\n  }\n']);

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(initializeUser),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(devLoginSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(refreshTokenSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(userJsonFromToken),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(tokenReceivedSaga),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(handleTokenNotReceived),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(handleLogout),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(sendFeedbackSaga),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(userSagas);

import { call, put, select, takeLatest } from 'redux-saga/effects';
import { mediaActions } from '@rosetta/gaia-media';
import { progressManagerHelper, progressActions } from '@rosetta/gaia-progress';
import { abActions } from '../../ab/redux/ab-reducer';
import { amplitudeHelper } from '../../events/amplitudeHelper';
import { GaiaApolloClient } from '../../gaia-data/apolloClient';
import { getAppActions, getAppSelectors, getErrorHandler, getLogger } from '../../gaia-data/init';
import { brazeHelper } from '../../events/brazeHelper';
import { submissionsActions } from '../../submissions/redux/submissions-reducer';
import { tutoringActions } from '../../tutoring/redux/tutoring-reducer';
import { DEV_ONLY_LOGIN, INIT_USER, LOGIN_VIA_TOKEN, LOGOUT, REFRESH_TOKEN, SEND_FEEDBACK, TOKEN_NOT_RECEIVED, TOKEN_RECEIVED, userActions, userSelectors } from './user-reducer';
import { initEve, clearTokens, getFeatureFlags, getToken, getTokenByRefreshToken, getUserJsonFromToken } from '../user-services';
import UAParser from 'ua-parser-js';
import gql from 'graphql-tag';

function initializeUser() {
  var isInitialized, languages, hasTutoring, userId, accessToken, isWebiUser, appFont, featureFlags, userInfo;
  return _regeneratorRuntime.wrap(function initializeUser$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return select(userSelectors.isUserInitialized);

        case 3:
          isInitialized = _context.sent;

          if (isInitialized) {
            _context.next = 57;
            break;
          }

          _context.next = 7;
          return select(userSelectors.getLanguages);

        case 7:
          languages = _context.sent;
          _context.next = 10;
          return put(getAppActions().setAppFontForLanguage(languages.learningLanguage));

        case 10:
          _context.next = 12;
          return put(getAppActions().installLionLanguage(languages.interfaceLanguage));

        case 12:
          _context.next = 14;
          return select(userSelectors.isTutoringAvailable);

        case 14:
          hasTutoring = _context.sent;

          if (!hasTutoring) {
            _context.next = 20;
            break;
          }

          _context.next = 18;
          return put(tutoringActions.startPollingNextTutoringSessionTime());

        case 18:
          _context.next = 20;
          return put(tutoringActions.loadTutoringSchedulerLaunchInfo());

        case 20:
          _context.next = 22;
          return select(userSelectors.getUserId);

        case 22:
          userId = _context.sent;
          _context.next = 25;
          return select(userSelectors.getAccessToken);

        case 25:
          accessToken = _context.sent;
          _context.next = 28;
          return put(progressActions.setLoadingMPProgressLibrary(true));

        case 28:
          _context.next = 30;
          return progressManagerHelper.userIdentified(userId, accessToken);

        case 30:
          _context.next = 32;
          return select(userSelectors.isWebiUser);

        case 32:
          isWebiUser = _context.sent;
          _context.next = 35;
          return select(getAppSelectors().appFont);

        case 35:
          appFont = _context.sent;
          _context.next = 38;
          return put(mediaActions.initializeMediaLib({
            apolloClient: GaiaApolloClient,
            isWebi: isWebiUser,
            contentFont: appFont,
            errorHandler: getLogger().sendToAirbrake
          }));

        case 38:
          _context.next = 40;
          return put(mediaActions.loadDecryptionKeys());

        case 40:
          _context.next = 42;
          return call(getFeatureFlags);

        case 42:
          featureFlags = _context.sent;
          _context.next = 45;
          return put(abActions.featureFlagsReceived(featureFlags));

        case 45:
          _context.next = 47;
          return select(userSelectors.getAllUserInfo);

        case 47:
          userInfo = _context.sent;
          _context.next = 50;
          return call(brazeHelper.initBrazeForUser, userInfo);

        case 50:
          _context.next = 52;
          return put(userActions.setUserInitialized());

        case 52:
          _context.next = 54;
          return put(submissionsActions.startPollingSubmissions());

        case 54:
          _context.next = 56;
          return call(amplitudeHelper.sendAmplitudeEvent, amplitudeHelper.analyticEventNames.APP_OPENED, {});

        case 56:

          initEve(userInfo);

        case 57:
          _context.next = 63;
          break;

        case 59:
          _context.prev = 59;
          _context.t0 = _context['catch'](0);
          _context.next = 63;
          return call(getErrorHandler(), { message: 'initializeUser fail: ' + _context.t0.message });

        case 63:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 59]]);
}

function devLoginSaga(action) {
  var userJson;
  return _regeneratorRuntime.wrap(function devLoginSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return call(getToken, action.payload.username, action.payload.password);

        case 3:
          userJson = _context2.sent;
          _context2.next = 6;
          return put(userActions.tokenReceived(userJson, action.payload.rememberMe));

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 12;
          return call(getErrorHandler(), { message: 'dev-only-login failed for user ' + action.payload.username });

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 8]]);
}

var refreshingToken = false;
//
function refreshTokenSaga() {
  var refreshToken, userJson;
  return _regeneratorRuntime.wrap(function refreshTokenSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (refreshingToken) {
            _context3.next = 21;
            break;
          }

          refreshToken = localStorage.getItem('refreshToken');
          _context3.prev = 2;

          refreshingToken = true;
          _context3.next = 6;
          return call(getTokenByRefreshToken, refreshToken);

        case 6:
          userJson = _context3.sent;

          if (userJson) {
            _context3.next = 12;
            break;
          }

          _context3.next = 10;
          return put(userActions.tokenNotReceived());

        case 10:
          _context3.next = 14;
          break;

        case 12:
          _context3.next = 14;
          return put(userActions.tokenReceived(userJson, true));

        case 14:
          refreshingToken = false;
          _context3.next = 21;
          break;

        case 17:
          _context3.prev = 17;
          _context3.t0 = _context3['catch'](2);
          _context3.next = 21;
          return call(getErrorHandler(), { message: 'refreshToken failed for token ' + refreshToken });

        case 21:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[2, 17]]);
}

function userJsonFromToken(action) {
  var userJson;
  return _regeneratorRuntime.wrap(function userJsonFromToken$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return call(getUserJsonFromToken, action.payload.token);

        case 3:
          userJson = _context4.sent;

          if (userJson) {
            _context4.next = 9;
            break;
          }

          _context4.next = 7;
          return put(userActions.tokenNotReceived());

        case 7:
          _context4.next = 11;
          break;

        case 9:
          _context4.next = 11;
          return put(userActions.tokenReceived(userJson, action.payload.rememberMe));

        case 11:
          _context4.next = 17;
          break;

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 17;
          return call(getErrorHandler(), { message: 'userJsonFromToken failed for token ' + action.payload.token });

        case 17:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 13]]);
}

var refreshTimeout = void 0;
function tokenReceivedSaga(action) {
  var _action$payload, rememberMe, userJson, isInitialized;

  return _regeneratorRuntime.wrap(function tokenReceivedSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _action$payload = action.payload, rememberMe = _action$payload.rememberMe, userJson = _action$payload.userJson;

          sessionStorage.setItem('token', userJson['access_token']);
          if (rememberMe) {
            localStorage.setItem('refreshToken', userJson['refresh_token']);
            refreshTimeout = setTimeout(function () {
              GaiaApolloClient.reduxStore.dispatch({ type: REFRESH_TOKEN });
            }, userJson.expires_in * 1000 + 10);
          } else {
            localStorage.removeItem('refreshToken');
          }
          _context5.next = 5;
          return select(userSelectors.isUserInitialized);

        case 5:
          isInitialized = _context5.sent;

          if (isInitialized) {
            _context5.next = 9;
            break;
          }

          _context5.next = 9;
          return put(userActions.initializeUser());

        case 9:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function handleTokenNotReceived() {
  return _regeneratorRuntime.wrap(function handleTokenNotReceived$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return clearTokens();

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function handleLogout() {
  return _regeneratorRuntime.wrap(function handleLogout$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          if (refreshTimeout) {
            clearTimeout(refreshTimeout);
            refreshTimeout = undefined;
          }
          _context7.next = 3;
          return clearTokens();

        case 3:
          _context7.next = 5;
          return put(tutoringActions.stopPollingNextTutoringSessionTime());

        case 5:
          _context7.next = 7;
          return put(tutoringActions.setNextTutoringSessionTime(undefined));

        case 7:
          _context7.next = 9;
          return put(tutoringActions.setTutoringSchedulerLaunchInfo(undefined));

        case 9:
          _context7.next = 11;
          return put(submissionsActions.startPollingSubmissions());

        case 11:
          _context7.next = 13;
          return put(submissionsActions.clearSubmissions());

        case 13:
          _context7.next = 15;
          return GaiaApolloClient.resetStore();

        case 15:
          _context7.next = 17;
          return progressManagerHelper.logout();

        case 17:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

/*
   input WebData {
    url: String!,
    browser: String!,
    os: String!,
    clientVersion: String!
   }
   input LearnerFeedback {
      userEmail: String,
      description: String!,
      webData: WebData,
      mobileData: MobileData,
      learningLanguage: String!,
      interfaceLanguage: String!,
      path: String,
   }
  where path is something unspecified that can identify where user was when she was sending feedback
*/
var SubmitFeedbackMutation = gql(_templateObject);

function sendFeedbackSaga(action) {
  var userLanguages, buildNumber, parser, userEmail, learnerFeedback;
  return _regeneratorRuntime.wrap(function sendFeedbackSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return select(userSelectors.getLanguages);

        case 2:
          userLanguages = _context8.sent;
          buildNumber = process.env.REACT_APP_BUILD_NUMBER !== undefined ? process.env.REACT_APP_BUILD_NUMBER : 'unknown';
          parser = new UAParser();
          _context8.next = 7;
          return select(userSelectors.getUserEmail);

        case 7:
          userEmail = _context8.sent;
          learnerFeedback = {
            description: action.payload.feedbackText,
            userEmail: userEmail,
            webData: {
              url: window.location.href,
              browser: _JSON$stringify(parser.getBrowser()),
              os: _JSON$stringify(parser.getOS()),
              clientVersion: buildNumber
            },
            learningLanguage: userLanguages.learningLanguage,
            interfaceLanguage: userLanguages.interfaceLanguage,
            path: ''
          };
          _context8.next = 11;
          return call(GaiaApolloClient.mutate, {
            mutation: SubmitFeedbackMutation,
            variables: {
              feedback: learnerFeedback
            },
            fetchPolicy: 'no-cache'
          });

        case 11:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

export function userSagas() {
  return _regeneratorRuntime.wrap(function userSagas$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return takeLatest(INIT_USER, initializeUser);

        case 2:
          _context9.next = 4;
          return takeLatest(DEV_ONLY_LOGIN, devLoginSaga);

        case 4:
          _context9.next = 6;
          return takeLatest(REFRESH_TOKEN, refreshTokenSaga);

        case 6:
          _context9.next = 8;
          return takeLatest(TOKEN_RECEIVED, tokenReceivedSaga);

        case 8:
          _context9.next = 10;
          return takeLatest(TOKEN_NOT_RECEIVED, handleTokenNotReceived);

        case 10:
          _context9.next = 12;
          return takeLatest(LOGOUT, handleLogout);

        case 12:
          _context9.next = 14;
          return takeLatest(SEND_FEEDBACK, sendFeedbackSaga);

        case 14:
          _context9.next = 16;
          return takeLatest(LOGIN_VIA_TOKEN, userJsonFromToken);

        case 16:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}